export default {
  // 为当前模块开启命名空间
  namespaced: true,

  // 模块的 state 数据
  state: () => ({
	token: localStorage.getItem('token') || '',
	iphoneInfo:{},
  }),

  // 模块的 mutations 方法
  mutations: {
	 // 更新 token 字符串
	   updateToken(state, token) {
	     state.token = token
	     // 通过 this.commit() 方法，调用 m_user 模块下的 saveTokenToStorage 方法，将 token 字符串持久化存储到本地
	     // this.commit('m_user/saveTokenToStorage')
	   },
	   updateIphoneInfo(state, iphoneInfo) {
	     state.iphoneInfo = iphoneInfo
	   },
  },

  // 模块的 getters 属性
  getters: {},
}